/**
 * Created on 2025-08-11.
 * Copyright © 2025 Curriculum Ltd. All rights reserved.
 */
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'curr-terms-of-use-popup',
  templateUrl: './terms-of-use-popup.component.html',
  styleUrls: ['./terms-of-use-popup.component.scss']
})
export class TermsOfUsePopupComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<TermsOfUsePopupComponent>
  ) { }

  ngOnInit(): void {
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
